/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyDollarCanadian = createReactComponent("outline", "currency-dollar-canadian", "IconCurrencyDollarCanadian", [["path", { "d": "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4", "key": "svg-0" }], ["path", { "d": "M10 18h-1a6 6 0 1 1 0 -12h1", "key": "svg-1" }], ["path", { "d": "M17 20v-2", "key": "svg-2" }], ["path", { "d": "M18 6v-2", "key": "svg-3" }]]);

export { IconCurrencyDollarCanadian as default };
//# sourceMappingURL=IconCurrencyDollarCanadian.mjs.map
